module.exports = __webpack_public_path__ + "img/5e50a86.png";